export default __webpack_public_path__ + "static/media/done.9bbc087e.png";